// extracted by mini-css-extract-plugin
export default {"title__text":"style_title__text__786Cy","title__updated-title":"style_title__updated-title__NXuVx","title__icon":"style_title__icon__tGTw7"};